
export const ChangePasswordFormValidator = values => {

    let errors = {};

    if (!values.oldPassword) {
        errors.oldPassword = 'Påkrævet';
    }

    if (!values.newPassword) {
        errors.newPassword = 'Påkrævet';
    }

    if (!values.confirmNewPassword) {
        errors.confirmNewPassword = 'Påkrævet';
    }

    if (values.newPassword && values.confirmNewPassword  && values.newPassword !== values.confirmNewPassword) {
        errors.confirmNewPassword = 'Kodeordene er ikke ens';
    }

    if (values.newPassword && !isValidPasswordFormat(values.newPassword)) {
        errors.newPassword = 'Adgangskoden kan ikke være kortere end 8 symboler og skal indeholde mindst et tal, små bogstaver og stor bogstaver';
    }

    return errors;
};


function isValidPasswordFormat(password) {
    let regex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[a-zA-Z\d]{8,}$/;
    return regex.test(password)
}


// WEBPACK FOOTER //
// ./web/src/components/users/ChangePasswordFormValidator.js